import { Breadcrumbs } from '@/shared/components/breadcrumbs';

/**
 * Global breadcrumb shown in <AppHeader>. Reads `handle.crumb` from React
 * Router's matched routes so labels can be parametric (e.g. "Staff #42") and
 * don't drift away from URL segments.
 */
export function AppBreadcrumbs() {
  return <Breadcrumbs />;
}
